import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  getotVendorsLists(_, payload) {
    return axios
      .get(`/api/vendor/list_vendor`, { params: payload })
      .then((res) => res.data);
  },
  getOtVendorDetails(_, id) {
    return axios.get(`/api/vendor/list_vendor/${id}`).then((res) => res.data);
  },

  createOtVendor(context, payload) {
    return axios
      .post("/api/vendor/add_vendor", payload)
      .then((res) => res.data);
  },

  saveRateCard(context, payload) {
    return axios
      .post(`/api/vendor/add_rate_card/${payload.vendor_name}`, payload)
      .then((res) => res.data);
  },
  getRateCardList(_, payload) {
    return axios
      .get(`/api/vendor/list_rate_card`, { params: payload })
      .then((res) => res.data);
  },
  getRateCardListDetails(_, id) {
    return axios
      .get(`/api/vendor/list_rate_card/${id}`)
      .then((res) => res.data);
  },
  getCardDetails(_, id) {
    return axios
      .get(`/api/vendor/list_rate_card/${id}`)
      .then((res) => res.data);
  },
  updateOtVendor(context, payload) {
    return axios
      .patch(`/api/vendor/edit_vendor/${payload.id}`, payload.data)
      .then((res) => res.data);
  },
  updateRatecard(context, payload) {
    return axios
      .patch(`/api/vendor/edit_rate_card/${payload.id}`, payload.data)
      .then((res) => res.data);
  },

  uploadTimesheet(context, payload) {
    return axios
      .post("/api/request_application/upload", payload)
      .then((res) => res.data);
  },
  getTimesheetList(_, payload) {
    if (payload.vendor_id == undefined) {
      return axios
        .get(`/api/request_application/list`, {
          params: payload,
        })
        .then((res) => res.data);
    } else {
      return axios
        .get(`/api/request_application/list?vendor_id=${payload.vendor_id}`, {
          params: payload,
        })
        .then((res) => res.data);
    }
  },
  timesheetDetails(_, payload) {
    return axios
      .get(`/api/request_application_employee/list/${payload.id}`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  getRateCardDetails(_, payload) {
    return axios
      .post(`/api/get_ratecard_details`, payload)
      .then((res) => res.data);
  },
  updateTimesheetStatus(context, payload) {
    return axios
      .patch(`/api/employee_status/updatebulk`, payload)
      .then((res) => res.data);
  },
  activeStatus(_, id) {
    return axios
      .get(`/api/request_application/inactive/${id}`)
      .then((res) => res.data);
  },
  updateApplication(context, payload) {
    return axios
      .patch(`/api/employee_status/update`, payload)
      .then((res) => res.data);
  },
  getattendanceList(_, payload) {
    return axios
      .get(`/api/vendor_employee_attendance/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  timesheetSummary(context, payload) {
    return axios
      .get(`/api/osl_summary_month_wise/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  summaryDetails(context, payload) {
    return axios
      .get(`/api/osl_summary_date_wise/list`, {
        params: payload,
      })
      .then((res) => res.data);
  },
  downloadListTemplate() {
    return axios
      .get(
        `/api/file_download?file_path=app_attendance/employee_application.xlsx`,
        {
          responseType: "blob",
        }
      )
      .then((res) => res);
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
